import isQA from './isQA';
import { getPortalId } from 'unified-navigation-ui/js/utils/getPortalId';
import { getFullUrl } from 'hubspot-url-utils';
export default function getElevatedJitaAccessLink(userEmail, accountName, scopes) {
  if (scopes.indexOf('nav-elevated-jita-access') === -1) {
    return undefined;
  }
  const params = {
    jitaType: 'ELEVATED',
    email: encodeURIComponent(userEmail),
    jitaDuration: isQA() ? 1440 : 60,
    loginPortalId: getPortalId(),
    loginPortalName: encodeURIComponent(accountName),
    loginRedirectUrl: encodeURIComponent(window.location.href)
  };
  const elevatedJitaUrl = `${getFullUrl('tools', {
    domainOverride: 'hubteam'
  })}/login/jita?`;
  return Object.keys(params).reduce((url, param) => {
    return `${url}${param}=${params[param]}&`;
  }, elevatedJitaUrl);
}